<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader :color="configureHeaderColor()" style="color:#fff;">{{currentStatus}}</CCardHeader>
      <CCardBody>
        <div style="width:100%;float:left;">
          <CDataTable
              :items="items"
              :fields="fields"
              pagination
              table-filter
              column-filter
              sorter
            >
            <template #view="{item}">
              <td>
                <CButton size="sm" color="info" @click="viewPdf(item, 'current')">View</CButton>
              </td>
            </template>
            <template #csr_assigned_name-header>
              CSR
            </template>
            <!-- <template #update="{item}">
              <td>
                <CButton size="sm" color="warning" @click="update(item)">Upload/Update</CButton>
              </td>
            </template> -->
            <template #as400_log_number="{item}">
              <td>
                <a class="btn btn-link" style="color:blue;text-decoration: underline;" @click="goToOrder(item)">{{item.as400_log_number}}</a>
              </td>
            </template>
            <template #csr_assigned="{item}">
              <td>
                {{item.csr_assigned.name}}
              </td>
            </template>
            <template #original="{item}">
              <td>
                <CButton size="sm" color="warning" @click="viewPdf(item, 'original')">View Original</CButton>
              </td>
            </template>
            <template #move="{item, index}">
              <td>
                <select class="form-control" v-model="item.csr_status" @change="statusChanged(item, index)">
                  <option value="">Change Status</option>
                  <option v-for="val in statuses" :value="val.status">{{val.text}}</option>
                </select>
              </td>
            </template>
          </CDataTable>
        </div>
      </CCardBody>

      <!-- <div style="width:100%;height:500px;" id="adobe-dc-view"></div> -->
    </CCard>

    <!-- <CModal
        title="PDF View"
        :show.sync="pdfModal"
        size="xl"
      >
      <div style="width:100%;float:left;" v-if="pdfModal">
        <small-loader v-if="downloadLoading"></small-loader>
        <div style="width:100%;float:left;text-align:center;" v-if="notExist">
          There is no PDF on the server for this log number. Please contact acoleman@paifashion.com
        </div>
        <div style="width:100%;height:500px;float:left;" id="adobe-dc-view"></div>
      </div>
      <template #footer>
        <CButton @click="currentPdf = null, pdfModal = false" color="danger">Cancel</CButton>
      </template>
    </CModal>
 -->

    <!-- <div class="pdfWrapper" style="width:100%;float:left;" v-if="pdfModal">
      <small-loader v-if="downloadLoading"></small-loader>
      
      <div v-show="!downloadLoading" style="width:100%;height:50px;text-align: center;padding-top:10px;">
        <CButton size="sm" @click="currentPdf = null, pdfModal = false" color="danger">Close</CButton>
      </div>
      <div v-show="!downloadLoading && !notExist" style="width:100%;height:calc(100% - 50px);" id="adobe-dc-view"></div>
      <div style="width:100%;height:calc(100% - 50px);text-align:center;background-color:#fff;" v-if="notExist">
        There is no PDF on the server for this log number. Please contact acoleman@paifashion.com if you think there should be.
      </div>
    </div> -->
    <adobe-pdf-viewer v-if="pdfModal && currentPdf && pdfType && allowEdit !== null" @closed="pdfModal = false, currentPdf = null, pdfType = null, allowEdit = null" :order_group="currentPdf" :pdf_type="pdfType" :allowEdit="allowEdit"></adobe-pdf-viewer>

  </div>
</template>
<script>
// var adobePdf = require('@adobe/pdfservices-node-sdk/src/pdfservices-sdk.js');
var methods = {}
import AdobePdfViewer from './adobe_pdf_viewer'
// import PdfViewer from './pdf_viewer'
// import PSPDFKit from 'pspdfkit';

methods.update = function (item) {
  this.updatePdf = item
  this.updateModal = true
}

methods.goToOrder = function (item) {
  this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
}

methods.configureHeaderColor = function () {
  var color = ''
  var that = this
  this.statuses.forEach(function (val) {
    if (val.status === that.currentStatus) {
      color = val.color
    }
  })
  return color
}

methods.statusChanged = function (item, index) {
  this.$emit('statusChanged', item, index)
}

methods.viewPdf = function (item, type) {
  this.downloadLoading = true
  console.log(item)
  this.notExist = false
  this.pdfModal = true
  this.currentPdf = item
  this.pdfType = type

  if (type === 'original') {
    this.allowEdit = false
  } else {
    this.allowEdit = true
  }

}

export default {
  // ===Component name
  name: "InnerPdfTable",
  // ===Props passed to component
  props: ['items', 'currentStatus'],
  // ===Components used by this component
  components: {
    // PSPDFKit,
    // PdfViewer
    AdobePdfViewer
  },
  // ====component Data properties
  data(){
      return{
        fields: ['order_id', 'as400_log_number', 'cc_number', 'csr_assigned_name', 'view', 'original', 'move'],
        pdfModal: false,
        currentPdf: null,
        downloadLoading: false,
        notExist: false,
        updatePdf: null,
        updateModal: false,
        uploadFile: null,
        pdfType: null,
        allowEdit: null,
        statuses: [
          {header: 'good_to_go', text: "Good To Go", color: 'success', status: 'Good To Go'},
          {header: 'send_to_art', text: "Send To Art/World Emblem", color: 'danger', status: 'Send To Art/World Emblem'},
          {header: 'hold', text: "Hold/Sent For Approval", color: 'warning', status: 'Hold/Sent For Approval'},
          {header: 'events', text: "Events-Check Shipping", color: 'info', status: 'Events-Check Shipping'},
        ]
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    // console.log(adobePdf)

    // document.addEventListener("adobe_dc_view_sdk.ready", function(){ 
    //   var adobeDCView = new AdobeDC.View({clientId: "c23f84ed3b4a4526b23c028a434760ea", divId: "adobe-dc-view"});
    //   adobeDCView.previewFile({
    //     content:{location: {url: "https://documentcloud.adobe.com/view-sdk-demo/PDFs/Bodea Brochure.pdf"}},
    //     metaData:{fileName: "Bodea Brochure.pdf"}
    //   }, {});
    // });

    // let adobe = document.createElement('script')
    // adobe.setAttribute('src', 'https://documentcloud.adobe.com/view-sdk/main.js')
    // document.head.appendChild(adobe)
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .pdfWrapper {
    width: 100%;
    height: 100%;
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(0,0,0,1);
    z-index:10000;
  }
</style>
